import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { historyInstance } from '~/history';
import { useEnvProvider } from '~/hooks';

const reactPlugin = new ReactPlugin();

export function AppInsights() {
  const { envConfig } = useEnvProvider();
  const appInsight = new ApplicationInsights({
    config: {
      instrumentationKey: envConfig.azureInsightsKey || '',
      extensions: [reactPlugin],
      extensionConfig: {
        [reactPlugin.identifier]: { history: historyInstance },
      },
    },
  });
  return appInsight;
}
